module.exports = __webpack_public_path__ + "static/img/testimony (33).b0ca4f60.jpg";